import $ from 'jquery'
import 'babel-polyfill'
import Foundation from './_foundation'
import 'motion-ui/dist/motion-ui'
import AOS from 'aos'
import './_notification'
// import { isMobile } from './_detect-useragent'
import throttle from 'lodash/throttle';
import '../../node_modules/jquery-parallax.js/parallax.min.js'
import { inlineSVG } from './_inline-svg'
import { lazyImages, lazyBackgrounds, lazyInterchange } from './_lazy-load'
import { smoothScrollOnPageLoad } from './_smoothScrollOnPageLoad';
import './_skip-link-focus-fix'
import './_acf-map'
import './_fixed-header'
import './_header-height'
import './_hero-slider'
import './_scroll-to-top'
import './_slick'
import './_off-canvas'
import './_faqs_accordion'
import './_fragmentURLs'
/* Additional Scripts */
// import { randomString } from './_random-string'
import './_ie'

// ** Foundation
$(document).foundation();


// ** Inline SVG
inlineSVG();


// ** Smooth Scroll on page load
smoothScrollOnPageLoad();


// **  Lazy-load on DOMContentLoaded
window.addEventListener( 'DOMContentLoaded', function() {
    lazyImages();
    lazyBackgrounds();
    lazyInterchange();

    // $('body').removeClass('is-reveal-open');
}, false);


// ** Lazy-load on scroll event
window.addEventListener( 'scroll', throttle( lazyImages, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyBackgrounds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyInterchange, 75 ), { passive: true } );


// ** AOS
AOS.init();


// ** Mobile menu (Off Canvas) - Append social menu to mobile menu
const $social_offcanvas_menu = $('.off-canvas__social-menu'),
      $offcanvas_menu = $('.off-canvas__menu'),
      menu_item_template = `<li class="menu-item menu-item--social-menu">${$social_offcanvas_menu.html()}</li>`;
      // $offcanvas_menu.append(menu_item_template);
      // $social_offcanvas_menu.remove();


// ** Detect iOS
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
if ( iOS ) {
    document.body.classList.add('is-ios');
}


// ** Append sub-menu to menu item
if ( Foundation.MediaQuery.atLeast('medium') ) {
    $( '<?php echo $append_menu_to_element; ?>' ).append( $( '.sub-menu[data-append="<?php echo $append_menu_to_element; ?>"]' ) );
}

// ** Fix label height of Gravty Forms
//jQuery(document).bind('gform_post_render', equalizeLabelHeight);

function equalizeLabelHeight( event, form_id, current_page ) {

    // if screen is no "small"
    if ( window.innerWidth > 750 && 3 == form_id ) {

      const $gf = $( '#gform_wrapper_3.gform_wrapper' );

      console.log($gf);

      $gf.find( 'li.gfield' ).each( function( i ) {
          
          if ( $(this).hasClass('gf_left_half') ) {
              
              var left_height  = $(this).find('.gfield_label'),
                  right_height = $(this).next('.gf_right_half').find('.gfield_label');

              if ( left_height.height() > right_height.height() ) {

                  right_height.height( left_height.height() );

              } else {

                  left_height.height( right_height.height() );

              }

          }

      });
      
    }

}

// ** Remove class to allow scrolling on load when the popup notification is enabled
setTimeout( function() {
  const $body = $('html,body');
  if ( $body.hasClass('is-reveal-open') ) {
    $body.removeClass('is-reveal-open');
  }
}, 2000 );


// ** Prevent the page from scroll when the mobile menu is open.
document.querySelector('.off-canvas__toggle').addEventListener('click', function() {
  document.body.classList.toggle('js-no-page-scroll');
});


// ** Detect Safari
var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if ( is_safari ) {
  document.body.classList.add('is-safari');
}


// Question Page - Align Form Fields
jQuery(document).on('gform_post_render', function() {

  console.log('form loaded');
 
  gf_fields_alignment();
 
});

function gf_fields_alignment() {
  if ( $('body').hasClass('page-id-2781') && $('#gform_6').length > 0 ) {
    
    let $form = $('#gform_6');
    
    $form.on('change',function() {

      console.log("change");
        
      var $visible_fields = $(this).find('.gfield:visible');
      
      $visible_fields.each( function(i) {

        let gf_class = 'gf_left_half gf_right_half';
        
        if ( i > 7 && i % 2 == 0 ) {
          
          // Even

          $(this).removeClass(gf_class).addClass('gf_right_half');

        } else if ( i > 7 ) {

          // Odd

          $(this).removeClass(gf_class).addClass('gf_left_half');

        }

      });

    })

  }  
}







